import { WithdrawnStatusView } from "./withdrawn-status-view.tsx";
import overlayStyles from "../shared/offboarding-page-overlay.module.css";

export interface WithdrawnStatusModalProps {
  open: boolean;
  withdrawalReason?: string | null;
  withdrawnDate?: string;
  loading?: boolean;
  onResign: () => void;
  updatedAt?: string | null;
}

/** Page-scoped withdrawn status dialog. */
export function WithdrawnStatusModal({
  open,
  withdrawalReason,
  withdrawnDate,
  loading = false,
  onResign,
  updatedAt,
}: WithdrawnStatusModalProps) {
  if (!open) return null;

  return (
    <div className={overlayStyles.overlay} role="presentation">
      <div
        className={overlayStyles.dialog}
        role="dialog"
        aria-modal="true"
        aria-label="Resignation withdrawn"
        onClick={(e) => e.stopPropagation()}
      >
        <WithdrawnStatusView
          withdrawalReason={withdrawalReason}
          withdrawnDate={withdrawnDate}
          loading={loading}
          onResign={onResign}
          updatedAt={updatedAt}
        />
      </div>
    </div>
  );
}
